const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ENDPOINTS = {
  LOGIN: `${BASE_URL}/auth/login`,
  LOGOUT: `${BASE_URL}/auth/logout`,
  FORGOT_PASSWORD: `${BASE_URL}/auth/forgot-password`,
  RESET_PASSWORD: `${BASE_URL}/auth/reset-password`,
  CHANGE_PASSWORD: `${BASE_URL}/user/change-password`,
  MESSAGE_STATS: `${BASE_URL}/user/message-stats`,
  DASHBOARD_ANALYTICS: `${BASE_URL}/user/dashboard-analytics`,
  MY_INFO: `${BASE_URL}/user/myinfo`,
  GET_CAMP_TEMPLATES: () => `${BASE_URL}/templates/get-templates`,
  GET_WA_TEMPLATE_COUNTS: `${BASE_URL}/wa/get_wa_template_counts`,
  CREATE_TEMPLATE: `${BASE_URL}/templates/create-template`,
  FETCH_TEMPLATES: (page = 1, limit = 10) =>
    `${BASE_URL}/wa/get_wa_templates/?page=${page}&limit=${limit}`,
  GET_WA_AP_TEMPLATES: `${BASE_URL}/wa/get_wa_ap_templates`,
  CREATE_WA_TEMPLATE: `${BASE_URL}/wa/create_wa_template`,
  UPLOAD_TEMPLATE_MEDIA: `${BASE_URL}/wa/create_uploadMedia`,
  UPLOAD_CAMPAIGN_MEDIA: `${BASE_URL}/wa/send_uploadMedia`,
  TEMPLATE_MAPPING: `${BASE_URL}/wamap/template-wa-mapping`,
  SEND_CAMPAIGN_MESSAGE: `${BASE_URL}/webhook/send-message`,
  SEND_CUSTOMISED_CAMPAIGN_MESSAGE: `${BASE_URL}/webhook/send-customized-message`,
  FETCH_REPORT: (templateId) => `${BASE_URL}/wa/report/${templateId}`,
  FETCH_STATUS: (templateId, status, page = 1, limit = 10) =>
    `${BASE_URL}/wa/reportstatus/${templateId}?status=${status}&page=${page}&limit=${limit}`,
  GET_CAMPAIGN_REPORT: `${BASE_URL}/wa/details-report`,
  NUMBER_MESSAGE_REPORT: `${BASE_URL}/wa/number-report`,
  GET_CHAT_HISTORY: `${BASE_URL}/user/get-chat-history`,
  DOWNLOAD_MEDIA: (mediaId) => `${BASE_URL}/user/media/${encodeURIComponent(mediaId)}`,
  SEND_WHATSAPP: `${BASE_URL}/whatsapp/send`,
  GET_INCOMING_MESSAGES: (page = 1, limit = 10, fromDate, toDate) => {
    let url = `${BASE_URL}/wa/get_incoming_messages?page=${page}&limit=${limit}`;
    if (fromDate) url += `&from_date=${fromDate}`;
    if (toDate) url += `&to_date=${toDate}`;
    return url;
  },
  GET_USER_FLOWS: `${BASE_URL}/bot/user-flows`,
  GET_FLOW_RESPONSES: `${BASE_URL}/bot/flow-responses`,
  AUTH_LOGS: `${BASE_URL}/user/auth-logs`,
  AUTO_REPLY: `${BASE_URL}/user/auto-reply`,
  AUTO_REPLY_SAVE: `${BASE_URL}/user/auto-reply/save`,
  BOT_DEFINITIONS: `${BASE_URL}/bot/definitions`,
  BOT_DEFINITION: (id) => `${BASE_URL}/bot/definitions/${id}`,
  BOT_PUBLISH: (id) => `${BASE_URL}/bot/definitions/${id}/publish`,
  BOT_ARCHIVE: (id) => `${BASE_URL}/bot/definitions/${id}/archive`,
  BOT_VALIDATE: (id) => `${BASE_URL}/bot/definitions/${id}/validate`,
  BOT_LOGS: (id) => `${BASE_URL}/bot/definitions/${id}/logs`,
  BOT_META_FLOWS: `${BASE_URL}/bot/meta-flows`,
  BOT_META_FLOW_SCREENS: (flowId) =>
    `${BASE_URL}/bot/meta-flows/${encodeURIComponent(flowId)}/screens`,
};
